import React, { Fragment } from "react";
import Form from "../common/Form";
import Row from "../common/Row";
import PropTypes from "prop-types";

const MeldingBevestigingForm = () => {

    return (
        <Fragment>
            <Form
                name="meldingen"
                isNotRequired
                headerVisible={false}>
                <div style={{ padding: "25px" }}>
                    <Row>
                        <p>
							Beste, <br /><br />
							We hebben jouw melding over grensoverschrijdend gedrag goed ontvangen en zullen deze met de uiterste zorg behandelen.<br />
							Je krijgt van ons een antwoord binnen de wettelijke termijn van 45 dagen.<br /><br />
							Met vriendelijke groeten,<br />
							Aanspreekpunt integriteit Sport Vlaanderen
						</p>
                    </Row>
                </div>
            </Form>
        </Fragment>
    );
};

MeldingBevestigingForm.propTypes = {
};

export default MeldingBevestigingForm;
